import {
  LdtStatusFilterValue,
  createOption,
} from '@ldt/features/orders/statuses/workflow_shared';
import { OrderStatus } from 'src/types';
import type { OrderStatusFilterOption } from 'src/types/status_filter';
import {
  isClinicAdmin,
  isCustomerSuccessOrSalesUser,
  isOrderingPhysician,
} from 'src/utils';

/** Ancillary Lab: CS/Sales "Processing" filter statuses (no ReportRejected/Lab*). */
const ANCILLARY_LAB_CS_PROCESSING_STATUSES: OrderStatus[] = [
  OrderStatus.AiProcessing,
  OrderStatus.AiError,
  OrderStatus.ReportPending,
  OrderStatus.ReportFaxPending,
  OrderStatus.ReportFaxFailed,
  OrderStatus.PathologyFaxPending,
  OrderStatus.PathologyFaxFailed,
];

/** Ancillary Lab: Ordering Physician / Clinic Admin "Processing" filter statuses. */
const ANCILLARY_LAB_OP_CA_PROCESSING_STATUSES: OrderStatus[] = [
  OrderStatus.QualityControlApproved,
  OrderStatus.PathologyFaxPending,
  OrderStatus.PathologyFaxFailed,
  OrderStatus.LabProcessing,
  OrderStatus.LabError,
  OrderStatus.AiProcessing,
  OrderStatus.AiError,
  OrderStatus.ReportPending,
  OrderStatus.ReportRejected,
];

export function getStatusFilterOptions(): Map<string, OrderStatusFilterOption> {
  const isCSOrSalesUser = isCustomerSuccessOrSalesUser();
  const isOrderingPhysicianOrClinicAdmin =
    isOrderingPhysician() || isClinicAdmin();

  if (isCSOrSalesUser) {
    return new Map<string, OrderStatusFilterOption>([
      createOption(LdtStatusFilterValue.ALL_ORDERS, 'All Orders'),
      createOption(LdtStatusFilterValue.REPORT_READY, 'Report Ready', [
        OrderStatus.ReportReady,
      ]),
      createOption(
        LdtStatusFilterValue.PROCESSING,
        'Processing',
        ANCILLARY_LAB_CS_PROCESSING_STATUSES,
      ),
      createOption(LdtStatusFilterValue.QC_PENDING, 'QC Pending', [
        OrderStatus.QualityControlPending,
      ]),
    ]);
  }

  if (isOrderingPhysicianOrClinicAdmin) {
    return new Map<string, OrderStatusFilterOption>([
      createOption(LdtStatusFilterValue.ALL_ORDERS, 'All Orders'),
      createOption(LdtStatusFilterValue.REPORT_READY, 'Report Released', [
        OrderStatus.ReportReady,
      ]),
      createOption(
        LdtStatusFilterValue.REPORT_FAX_PENDING,
        'Report Fax Pending',
        [OrderStatus.ReportFaxFailed, OrderStatus.ReportFaxPending],
      ),
      createOption(LdtStatusFilterValue.REPORT_FAXED, 'Report Faxed', [
        OrderStatus.ReportFaxed,
      ]),
      createOption(
        LdtStatusFilterValue.PROCESSING,
        'Processing',
        ANCILLARY_LAB_OP_CA_PROCESSING_STATUSES,
      ),
      createOption(LdtStatusFilterValue.QC_PENDING, 'Order Created', [
        OrderStatus.QualityControlPending,
      ]),
    ]);
  }

  throw new Error('Invalid user role');
}
